import { FunctionalComponent, h } from "preact";
import styles from "./categoryFiltersStyles.css";
import ArrowIcon from "../../../assets/icons/ArrowIcon";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { Tag } from "../../../models/interfaces";
import PortalTags from "./Components/PortalTags";
import CategoryTags from "./Components/CategoryTags";
import { useEffect, useState } from "preact/hooks";
import FilterCloseIcon from "../../../assets/icons/filterCloseIcon";
import { setInputValue } from "../../../redux/slices/searchSlice";
import NestedTags from "./Components/NestedTags";
interface IProps {
  selectAllTopics: () => void;
  isAllTopics: () => boolean;
  filtersToggleKappSelection: (kapp: any) => void;
  filterTagsForUI: (tag: Tag) => boolean;
  tagClicked: (tag: Tag) => void;
  removeTag: (tag: any) => void;
  handleCheckboxChange: any;
  selectedCategory: any;
  OnApplyFilters?: () => void;
  clearAllFilters: () => void;
  clearCategoryFilters: () => void;
  selectedItems: any;
  // inputValue: string;
  setUpdateNestedTags?: (value: any) => void;
  handleNestedTagChange?: (value: any) => void;
}
const CategoryFilters: FunctionalComponent<IProps> = ({
  filterTagsForUI,
  tagClicked,
  removeTag,
  selectAllTopics,
  isAllTopics,
  filtersToggleKappSelection,
  handleCheckboxChange,
  selectedCategory,
  OnApplyFilters,
  clearCategoryFilters,
  clearAllFilters,
  selectedItems,
  setUpdateNestedTags,
  handleNestedTagChange,
}) => {
  const appearance = useAppSelector((state) => state.appearance);
  const search = useAppSelector((state) => state.search);
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(true); // State to track open/close
  const [value, setValue] = useState("");
  const toggleFilters = () => {
    setIsOpen(!isOpen); // Toggle the open state
  };
  useEffect(() => {
    if (search?.inputValue) setValue(search.inputValue);
  }, [search.inputValue]);
  // Function to handle input change
  const handleInputChange = (event: any) => {
    setValue(event.target.value);
    dispatch(setInputValue(event.target.value));
  };
  const handleEnter = (event: any) => {
    if (event.key === "Enter" && search) {
      event.preventDefault();
      // dispatch(setInputValue(event.target.value));
      if (OnApplyFilters) OnApplyFilters();
    }
  };
  return (
    <div className={styles.filterWrapper}>
      <div className={styles.filterheader}>
        {isOpen ? <p className={styles.title}>Filters</p> : <span></span>}
        {isOpen ? (
          <span onClick={toggleFilters} style={{ cursor: "pointer" }}>
            <ArrowIcon />
          </span>
        ) : (
          <span onClick={toggleFilters} style={{ cursor: "pointer" }}>
            <FilterCloseIcon />
          </span>
        )}
      </div>
      <div
        className={
          isOpen ? styles.filterContainerOpen : styles.filterContainerClose
        }
      >
        <div className={styles.searchWrapper}>
          <div className={styles.searchWrapperFooter}>
            {appearance.showKeywordFilter && (
              <p className={styles.subTitle}>Filter by keyword</p>
            )}
            {(value ||
              selectedCategory?.length > 0 ||
              selectedItems.length > 0 ||
              search.selectedNestedTags?.length > 0) && (
              <span
                style={{
                  textAlign: "end",
                  width: appearance.showKeywordFilter ? "" : "100%",
                }}
                onClick={() => {
                  setValue("");
                  clearCategoryFilters();
                  clearAllFilters();
                }}
              >
                Clear all
              </span>
            )}
          </div>
          {appearance.showKeywordFilter && (
            <div className={styles.searchContainer}>
              <img src="/assets/icons/search_gray.svg" />
              <input
                type="text"
                value={value}
                onKeyPress={handleEnter}
                placeholder="Enter keyword"
                onChange={handleInputChange}
              />
            </div>
          )}
        </div>
        <div
          className={styles.contentContainer}
          style={{
            height: appearance.showKeywordFilter ? "35vh" : "45vh",
          }}
        >
          <PortalTags
            filterTagsForUI={filterTagsForUI}
            tagClicked={tagClicked}
            removeTag={removeTag}
            selectAllTopics={selectAllTopics}
            isAllTopics={isAllTopics}
            filtersToggleKappSelection={filtersToggleKappSelection}
          />
          {appearance.filtersType === "category" ? (
            <CategoryTags
              handleCheckboxChange={handleCheckboxChange}
              selectedCategory={selectedCategory}
            />
          ) : null}
          {/* {appearance.filtersType === "category" ? (
            <NestedTags
              setUpdateNestedTags={setUpdateNestedTags}
              handleNestedTagChange={handleNestedTagChange}
            />
          ) : null} */}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilters;
